import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import TreatmentProcess from './components/TreatmentProcess';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import BookingCTA from './components/BookingCTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Loader from './components/Loader';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate initial asset loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && <Loader key="loader" />}
      </AnimatePresence>
      
      {!isLoading && (
        <div className="min-h-screen bg-white font-sans text-slate-900 animate-fade-in-up">
          <Header />
          <main>
            <Hero />
            <About />
            <Services />
            <TreatmentProcess />
            <WhyChooseUs />
            <div id="testimonials">
              <Testimonials />
            </div>
            <div id="booking">
              <BookingCTA />
            </div>
            <Contact />
          </main>
          <Footer />
          <FloatingWhatsApp />
        </div>
      )}
    </>
  );
}

export default App;